import { render, staticRenderFns } from "./LeadTransferRulesNotice.vue?vue&type=template&id=4a358102&"
import script from "./LeadTransferRulesNotice.vue?vue&type=script&lang=js&"
export * from "./LeadTransferRulesNotice.vue?vue&type=script&lang=js&"
import style0 from "./LeadTransferRulesNotice.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/modules/leads/ui/components/LeadTransferRulesNotice.vue
// module id = 1450
// module chunks = 0